(function(angular, _) {
    'use strict';

    /**
     * @ngdoc service
     * @name WtNotificationBanner
     * @description Wrapper for wtUi.wtNotifications wtNotificationsProvider message
     * Represents a notification that will be displayed to the end user which requires no interaction from the user
     * @example ```
     *  var notification = new WtNotificationBanner('Example {{token}} with placeholders');
     *  notification.setDuration(2000);
     *  notification.setMessageType('info');
     *  notification.setTranslateParams({token: 'message'});
     *
     *  // Feed it to the wt-ui-components notifications service
     *  wtNotifications.info(notification);
     * ```
     */
    angular.module('wtApp.dataService').factory('WtNotificationBanner', function() {
        return WtNotificationBanner;
    });

    function WtNotificationBanner(iMessage) {
        var messageKeys = _.keys(WtNotificationBanner.defaults);

        this.message = _.assign({}, WtNotificationBanner.defaults);

        if (_.isPlainObject(iMessage)) {
            this.message = _.assign({}, this.message, _.pick(iMessage, messageKeys));
        } else {
            this.setContent(iMessage);
        }

        // Define direct getters on the object
        _.forEach(messageKeys, function(messageKey) {
            Object.defineProperty(this, messageKey, {
                configurable: false,
                enumerable: true,
                get: function() {
                    return this.message[messageKey];
                }
            });
        }.bind(this));
    }

    WtNotificationBanner.defaults = {
        content: '',
        duration: 4000,
        className: 'info',
        translateParams: {},
        stay: false
    };

    WtNotificationBanner.types = ['success', 'info', 'error', 'warning'];

    /**
     * @ngdoc method
     * @name WtNotificationBanner#setContent
     * @description Set message content
     * @param {string} iMessage Message content
     * @returns {WtNotificationBanner}
     */
    WtNotificationBanner.prototype.setContent = function setContent(iMessage) {
        this.message.content = String(iMessage);

        return this;
    };

    /**
     * @ngdoc method
     * @name WtNotificationBanner#setDuration
     * @description Sets message duration
     * @param {number} iDuration Message duration
     * @returns {WtNotificationBanner}
     */
    WtNotificationBanner.prototype.setDuration = function setDuration(iDuration) {
        this.message.duration = (Number(iDuration) > 0 ? Number(iDuration) : WtNotificationBanner.defaults.duration);

        return this;
    };

    /**
     * @ngdoc method
     * @name WtNotificationBanner#setMessageType
     * @description Sets message type
     * @param {string} iType
     * @returns {WtNotificationBanner}
     */
    WtNotificationBanner.prototype.setMessageType = function setMessageType(iType) {
        var type = String(iType);

        if (WtNotificationBanner.types.indexOf(type) > -1) {
            this.message.className = type;
        }

        return this;
    };

    /**
     * @ngdoc method
     * @name WtNotificationBanner#setTranslationParams
     * @description Sets translation parameters
     * @param {Object} iParams Translation parameters
     * @returns {WtNotificationBanner}
     */
    WtNotificationBanner.prototype.setTranslationParams = function setTranslationParams(iParams) {
        this.message.translateParams = (_.isPlainObject(iParams) ? iParams : {});

        return this;
    };

    /**
     * @ngdoc method
     * @name WtNotificationBanner#getPayload
     * @description Gets the message payload
     * @returns {Object}
     */
    WtNotificationBanner.prototype.getPayload = function getPayload() {
        return this.message;
    };

    /**
     * @ngdoc method
     * @name WtNotificationBanner#toJSON
     * @description JSON representation of the message
     * @returns {{className: string, duration: number, translateParams: {}, content: string}|*}
     */
    WtNotificationBanner.prototype.toJSON = function toJSON() {
        return this.getPayload();
    };

    /**
     * @ngdoc method
     * @name WtNotificationBanner#toString
     * @description Serialize the message
     * @returns {string}
     */
    WtNotificationBanner.prototype.toString = function toString() {
        return this.message.content;
    };
})(window.angular, window._);
